export default function registerSubheader($, apower) {
  //subheader visibility
  apower.subheader = $.registerOnce(".subheader", {
    props: ["fixed-screen"],

    fixedScreen: false,

    visible: false,

    whenToShow: undefined,

    whenToHide: Infinity,

    init: function () {
      this.whenToShow = $(window).height();

      if (!this.fixedScreen) {
        if (window.innerWidth > 768) {
          apower.scroller.on("scroll", this.onScroll, this);
        } else {
          apower.scroller.on("up", this.onScrollUp, this);
          apower.scroller.on("down", this.onScrollDown, this);
        }
      }
    },

    onScroll: function (scrollTop) {
      var newVisible =
        scrollTop >= this.whenToShow && scrollTop < this.whenToHide;

      if (newVisible !== this.visible) {
        if (newVisible) {
          this.el.stop().fadeIn(300);
        } else {
          this.el.stop().fadeOut(300);
        }
      }

      this.visible = newVisible;
    },

    onScrollUp: function () {
      this.el.stop().hide();
    },

    onScrollDown: function () {
      this.el.stop().show();
    },
  });

  //subheader reviews
  $.registerOnce(".subheader .open-reviews", {
    init() {
      this.el.$on("click", this.openReviews, this);
    },
    openReviews() {
      var reviewWin = $(".review-win").com() || $.newCom("review");
      reviewWin.show();
    },
  });
}
